exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* make sure to keep these in sync with other constants,\r\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\r\n\r\n/* layout contants from `layout-constants.js` */\r\n\r\n.target-pane_target-pane_2ZTsJ {\r\n    /* Makes columns for the sprite library selector + and the stage selector */\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-grow: 1;\r\n}\r\n\r\n.target-pane_stage-selector-wrapper_2LIOy {\r\n    display: flex;\r\n    flex-basis: 72px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n[dir=\"ltr\"] .target-pane_stage-selector-wrapper_2LIOy {\r\n    margin-left: calc(0.5rem / 2);\r\n}\r\n\r\n[dir=\"rtl\"] .target-pane_stage-selector-wrapper_2LIOy {\r\n    margin-right: calc(0.5rem / 2);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"target-pane": "target-pane_target-pane_2ZTsJ",
	"targetPane": "target-pane_target-pane_2ZTsJ",
	"stage-selector-wrapper": "target-pane_stage-selector-wrapper_2LIOy",
	"stageSelectorWrapper": "target-pane_stage-selector-wrapper_2LIOy"
};